import { Link } from 'react-router-dom';
import { company, navigation } from '@/mocks/site';
import { services } from '@/mocks/services';
import BrandLogo from '@/components/feature/BrandLogo';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="relative overflow-hidden bg-primary-950 text-background-100">
      <div className="h-[3px] w-full bg-accent-500" />
      <div className="absolute inset-0 hatch-lines-light opacity-40" />
      <div className="container-wide relative z-10 pt-16 md:pt-20">
        <div className="grid gap-12 lg:grid-cols-[1.3fr_1fr_0.8fr_1fr]">
          <div>
            <BrandLogo onDark markSize={54} tagline="Travaux industriels lourds" />
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-background-300">
              Partenaire industriel au Cameroun. Chaudronnerie, tuyauterie, soudure et montage
              d'ouvrages pour un développement industriel durable et sécurisé.
            </p>
            <div className="mt-7 flex items-center gap-3">
              <a
                href={company.phoneHref}
                aria-label="Appeler SGSCTIC"
                className="flex h-10 w-10 items-center justify-center border border-background-50/20 text-background-100 transition-colors duration-300 hover:border-primary-500 hover:bg-primary-500 hover:text-background-50"
              >
                <i className="ri-phone-line" />
              </a>
              <a
                href={`mailto:${company.email}`}
                aria-label="Écrire à SGSCTIC"
                className="flex h-10 w-10 items-center justify-center border border-background-50/20 text-background-100 transition-colors duration-300 hover:border-primary-500 hover:bg-primary-500 hover:text-background-50"
              >
                <i className="ri-mail-line" />
              </a>
              <Link
                to="/contact"
                aria-label="Nous contacter"
                className="flex h-10 w-10 items-center justify-center border border-background-50/20 text-background-100 transition-colors duration-300 hover:border-primary-500 hover:bg-primary-500 hover:text-background-50"
              >
                <i className="ri-chat-3-line" />
              </Link>
            </div>
          </div>

          <div>
            <h3 className="label-mono text-accent-400">Expertises</h3>
            <ul className="mt-6 space-y-3 text-sm">
              {services.slice(0, 6).map((service) => (
                <li key={service.slug}>
                  <Link
                    to="/offres"
                    className="text-background-300 transition-colors duration-300 hover:text-background-50"
                  >
                    {service.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="label-mono text-accent-400">Navigation</h3>
            <ul className="mt-6 space-y-3 text-sm">
              {navigation.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="text-background-300 transition-colors duration-300 hover:text-background-50"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/identite"
                  className="text-background-300 transition-colors duration-300 hover:text-background-50"
                >
                  Charte graphique
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="label-mono text-accent-400">Nous joindre</h3>
            <ul className="mt-6 space-y-4 text-sm text-background-300">
              <li className="flex gap-3">
                <i className="ri-map-pin-2-line mt-0.5 text-accent-400" />
                <span>{company.address}</span>
              </li>
              <li className="flex gap-3">
                <i className="ri-phone-line mt-0.5 text-accent-400" />
                <a href={company.phoneHref} className="transition-colors hover:text-background-50">
                  {company.phone}
                </a>
              </li>
              <li className="flex gap-3">
                <i className="ri-mail-line mt-0.5 text-accent-400" />
                <a
                  href={`mailto:${company.email}`}
                  className="break-all transition-colors hover:text-background-50"
                >
                  {company.email}
                </a>
              </li>
              <li className="flex gap-3">
                <i className="ri-time-line mt-0.5 text-accent-400" />
                <span>{company.hours}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-3 border-t border-background-50/10 py-7 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} SGSCTIC — Tous droits réservés.</p>
          <Link
            to="/identite"
            className="flex items-center gap-2 text-background-400 transition-colors hover:text-background-100"
          >
            <i className="ri-palette-line text-accent-400" />
            Charte graphique &amp; identité visuelle
          </Link>
          <p className="flex items-center gap-2">
            <span className="h-1.5 w-1.5 bg-primary-500" />
            Douala, Cameroun · Cameroun &amp; sous-région
          </p>
        </div>
      </div>

      <div className="pointer-events-none relative z-0 select-none">
        <div className="container-wide">
          <span className="block translate-y-[22%] font-heading text-[19vw] font-semibold uppercase leading-none tracking-[0.02em] text-outline">
            SGSCTIC
          </span>
        </div>
      </div>
    </footer>
  );
}